import { ReactNode } from "react";
import { Heading } from "@chakra-ui/react";
import { Flex } from '@chakra-ui/react'
import { Image } from '@chakra-ui/react'

type Props = {
    children?: ReactNode;
  };

export default function Breadcrumbs({ children }: Props) {
    return (<div className="gamfi-breadcrumbs-section">
    <div className="container">
      <div className="row">
        <div className="col-lg-7">
          <div className="breadcrumbs-area sec-heading">
            <Flex alignItems={"center"} className="sub-inner mb-15" columnGap={"5px"}>
              <span className="sub-title">Earn $HERA</span>
              <Image
              height={"10px"}
                className="heading-left-image"
                src="assets/images/icons/steps.png"
                alt="Steps-Image"
              />
            </Flex>
            <Heading className="title mb-0">A.I. Trade Mining Portal</Heading>
          </div>
        </div>
        <div className="col-lg-5 breadcrumbs-form md-mt-40">
          <div className="btn-area">
            <a className="btn readon black-shape portalbtn text-dark fw-bolder" href="https://portal.hera.finance" target="blank">
              <span className="btn-text">New Staking Portal ↗</span>
              <span className="hover-shape1" />
              <span className="hover-shape2" />
              <span className="hover-shape3" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}